import { apiClient } from "./apiClient";
import type {
  EmbedTokenSummary,
  EmbedTokenCreated,
  CreateEmbedTokenRequest,
  UpdateEmbedTokenRequest,
  EmbedExposedItem,
  SetEmbedExposedItemRequest,
  EmbedOriginStats,
  EmbedVoucherLookup,
  EmbedVoucherUseResult,
} from "../types/embedWidget";

export const embedWidgetService = {
  listTokens(token: string): Promise<EmbedTokenSummary[]> {
    return apiClient.get<EmbedTokenSummary[]>("/business-embed/tokens", token);
  },

  createToken(token: string, req: CreateEmbedTokenRequest): Promise<EmbedTokenCreated> {
    return apiClient.post<EmbedTokenCreated>("/business-embed/tokens", req, token);
  },

  updateToken(token: string, tokenId: string, req: UpdateEmbedTokenRequest): Promise<void> {
    return apiClient.patch<void>(`/business-embed/tokens/${tokenId}`, req, token);
  },

  revokeToken(token: string, tokenId: string): Promise<void> {
    return apiClient.delete<void>(`/business-embed/tokens/${tokenId}`, token);
  },

  listExposed(token: string): Promise<EmbedExposedItem[]> {
    return apiClient.get<EmbedExposedItem[]>("/business-embed/exposed", token);
  },

  setExposed(token: string, req: SetEmbedExposedItemRequest): Promise<void> {
    return apiClient.put<void>("/business-embed/exposed", req, token);
  },

  getAnalytics(token: string, days = 30): Promise<EmbedOriginStats[]> {
    return apiClient.get<EmbedOriginStats[]>(`/business-embed/analytics?days=${days}`, token);
  },

  lookupVoucher(token: string, code: string): Promise<EmbedVoucherLookup> {
    return apiClient.get<EmbedVoucherLookup>(
      `/business-embed/vouchers/lookup?code=${encodeURIComponent(code)}`,
      token
    );
  },

  useVoucher(token: string, purchaseId: string): Promise<EmbedVoucherUseResult> {
    return apiClient.post<EmbedVoucherUseResult>(
      `/business-embed/vouchers/${purchaseId}/use`,
      undefined,
      token
    );
  },
};
